import { FC, ReactNode, useMemo } from "react"
import Tooltip from "../../tool-tip"

// Convert value to string for tooltip display
const getValueString = (value: ReactNode) => {
  if (typeof value === "string") return value
  if (typeof value === "number") return value.toString()
  return "-"
}

interface Props {
  label?: string
  value?: ReactNode
  className?: string
  h?: number | string
  noFixedHeight?: boolean
  truncateValue?: boolean
}

const SectionCell: FC<Props> = ({
  className = "",
  label,
  value,
  h = 7,
  noFixedHeight = false,
  truncateValue = false
}) => {
  const ValueContent = (
    <div
      className={`text-neutral-900 ${
        noFixedHeight ? "" : typeof h === "number" ? `h-${h}` : h
      } ${truncateValue ? "truncate" : ""}`}
      dangerouslySetInnerHTML={{
        __html:
          typeof value === "string"
            ? value
            : typeof value === "number"
            ? value + ""
            : "-"
      }}
    />
  )

  const text = useMemo(() => getValueString(value), [value])

  return (
    <div className={`${className} pt-6`}>
      {label ? (
        <div className="pb-1 text-neutral-400">{label}</div>
      ) : (
        <div className="h-6" />
      )}

      {truncateValue ? (
        <Tooltip toolTipNode={ValueContent} text={text} />
      ) : (
        ValueContent
      )}
    </div>
  )
}

export default SectionCell
